//import 'slick-carousel'
import landing from './templateLandingPage';

export default {
  init() {
    // JavaScript to be fired on the home page
    this.homepageCarousel();
    this.mirrorEffect();
    landing.parallaxImage();
    landing.slider();
    landing.appendUTMQueryParamsToCtas();
    landing.playVideoOnScroll();
  },
  mirrorEffect() {
    if ($(window).width() > 1200) {
      $('#effect').mousemove(function (e) {
        $('#effect-mirror').css('clip-path', 'circle(60px at ' + e.offsetX + 'px ' + e.offsetY + 'px)')
        $('#effect-mirror').css('visibility', 'visible');
      });

      $('#effect').mouseleave(function (e) {
        $('#effect-mirror').css('clip-path', 'circle(0px at ' + e.offsetX + 'px ' + e.offsetY + 'px)');
        $('#effect-mirror').css('visibility', 'hidden');
      });
    }
  },
  homepageCarousel() {
    if (!$('.our-products').length) {
      return;
    }

    $('.our-products.mobile .slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      infinite: false,
    });

    $('.our-products.mobile .slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      dots: false,
      infinite: false,
      centerMode: true,
      asNavFor: '.slider-nav',
    });


    $(window).scroll(function () {
      const allCategories = $('.our-products .select-category');

      if ($(window).scrollTop() >= $('.our-products').offset().top - 700) {
        $(allCategories[0]).trigger('mouseover');
        $(window).unbind('scroll');
      } else {
        $('.our-products video')[0].pause();
      }
    });

    // Update line when hovering the gateway list
    $('.our-products .select-category').on('mouseenter', function(){

      var that = $(this);
      $('.our-products video[data-category]').each(function(){
        $(this)[0].pause();
        $(this)[0].currentTime = 0;
        $(this).off('ended');
      });
      const next = ($(that).next().length) ? $(that).next() : $('.our-products .select-category').eq(0);

      let selected_category = that.find('p').data('category');
      const selectedVideo = $('.our-products video[data-category="'+selected_category+'"]');

      $('.our-products .select-category').removeClass('active');
      that.addClass('active');

      $('.our-products video[data-category]').removeClass('active');
      $(selectedVideo).addClass('active');
      $(selectedVideo)[0].play();
      $(selectedVideo).on('ended',function(){
        if (!$(that).is(':hover')) {
          $(selectedVideo)[0].currentTime = 0;
          $(next).trigger('mouseover')
        }
      });
      // Update line
      $(selectedVideo).bind('timeupdate', function(){

        var current_time = $(this)[0].currentTime;
        var duration = $(this)[0].duration;
        var duration_converted_percentage = current_time/(duration*0.01);

        $(this).append('<style>.our-products .timeline[data-category="'+selected_category+'"]:after { height: '+duration_converted_percentage+'%; } </style>');

      });

    })

    $(window).on('resize orientationChange', function() {

      $('.our-products.mobile .slider-nav').slick('reinit');
      $('.our-products.mobile .slider-for').slick('reinit');

    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    var that = this;
    $(window).on('resize orientationChange', function() {
      that.mirrorEffect();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js